<ng-template>
  <h1>
    <ng-content />
  </h1>
</ng-template>
